import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ChestStatus, Prize } from 'src/app/treasure/chest-status';
import { TreasureService } from 'src/app/treasure/treasure.service';

@Component({
  selector: 'app-treasure',
  templateUrl: './treasure.component.html',
  styleUrls: ['./treasure.component.scss']
})
export class TreasureComponent implements OnInit {

  chestIsOpen = false;
  chancesLeft = 1;
  histories = [
    {icon: 'frown', message: 'You missed! Try again.'},
    {icon: 'star', message: 'You got 23 RP.'},
    {icon: 'star', message: 'You got 500 RP.'},
  ];

  chestStatus$: Observable<ChestStatus>;
  prize$: Observable<Prize[]>;
  allow$: Observable<boolean>;
  open$: Observable<{Success: boolean; Message: string; }>;

  constructor(private treasureService: TreasureService) { }

  ngOnInit(): void {
    this.chestStatus$ =
    this.treasureService.isAllowOpen()
    .pipe(
      shareReplay()
    );

    this.prize$ =
    this.chestStatus$
    .pipe(
      map(chest => chest.Data)
    );

    this.allow$ =
    this.chestStatus$
    .pipe(
      map(chest => chest.Message === 'User Not Allow to open box' ? false : true )
    );
  }

  onOpenChest() {
    this.open$ =
    this.treasureService.openChest()
    .pipe(
      shareReplay()
    );
  }


}
